module.exports = __webpack_public_path__ + "files/dbdada8a05903efb735499ff8041646c.svg";


/*****************
 ** WEBPACK FOOTER
 ** ./non_npm_dependencies/google-fonts/fonts/Droid-Serif-regular.svg
 ** module id = 846
 ** module chunks = 0
 **/